var a="\n    gl_FragColor.a = 1.0;\n";export{a as default};
